export const COLUMN = 'property-list-editor-column';
export const DRAGDROP_TYPE = 'PROPERTY_LIST_EDITOR_DRAGDROP_OPTION';
export const LAST_ITEM = {};
export const PROPERTY = 'property-list-editor-property';
export const PROPERTIES_TYPE = 'PROPERTIES';
export const EDITOR_WIDTH = 1000;